/*
 * Initials for the header badge, derived from authInfo.displayName.
 *
 * The names this receives are not tidy: /srmo/info returns both personal names
 * ("Dionysios BALTIMAS") and organisation-shaped strings with punctuation and
 * non-ASCII letters ("Slovenske železnice, d.o.o."), sometimes with stray
 * whitespace. So: split on any run of whitespace, take the first letter of the
 * first and last tokens, and never return more than two characters.
 *
 * Each initial is uppercased on its own and then truncated back to one code
 * point, because some letters grow when uppercased (German "ß" -> "SS") and
 * uppercasing the pair as a whole could yield three characters.
 */
function firstLetterUpper(token) {
    const codePoints = Array.from(token);
    const first = codePoints.length > 0 ? codePoints[0] : "";
    const upper = Array.from(first.toLocaleUpperCase());
    return upper.length > 0 ? upper[0] : "";
}
export function getUserInitials(displayName) {
    const tokens = String(displayName ?? "")
        .trim()
        .split(/\s+/)
        .filter((token) => token.length > 0);
    if (tokens.length === 0)
        return "";
    const first = firstLetterUpper(tokens[0]);
    if (tokens.length === 1)
        return first;
    return first + firstLetterUpper(tokens[tokens.length - 1]);
}
